/* sb-dc-tplfit.js — let an uploaded template reach the edge of the board.

   Templates that come from the admin panel are laid onto the artboard as a
   single image layer, fitted "contain" at 96%. That 4% is why every uploaded
   template renders with a white frame around it: 2% of the board on each side.
   On an 11x3 bumper sticker that is a hairline; on an 8ft step & repeat it is
   a two-inch white border, which is not what the artwork was drawn for.

   The builder that applies the 96% lives inside the 320KB augment bundle, so
   it is corrected here instead — same reason sb-dc-tplnames.js exists.

   WHAT IT WILL AND WILL NOT TOUCH

   Growing a layer the customer did not ask to grow would be worse than the
   white frame, so this only fires on the exact fingerprint the builder leaves:

     - the document holds exactly one layer, and that layer is an image
     - the layer is centred on the board within half a percent
     - the layer measures 94-98% of a "contain" fit

   A photo the customer dropped in and positioned themselves fails at least one
   of those in practice. Each layer is also only ever adjusted once.

   Note this makes the artwork "contain at 100%", not "cover". A template whose
   aspect ratio does not match the board still shows white on the long axis —
   that is correct. Filling it would mean cropping or distorting the design.

   If it does not fire, window.__dcTplFitDebug() reports what it saw; the
   likely cause is that the layer geometry uses field names not in GEOM below.
*/
(function () {
  'use strict';

  var LO = 0.94, HI = 0.98;        // the builder's fit, with room for rounding
  var CENTRE_TOL = 0.005;          // half a percent of the board
  var done = Object.create(null);
  var last = null;                 // for __dcTplFitDebug

  /* Field-name sets seen across versions of the document format. */
  var GEOM = [
    ['x', 'y', 'w', 'h'],
    ['xIn', 'yIn', 'wIn', 'hIn'],
    ['left', 'top', 'width', 'height']
  ];

  function geomKeys(layer) {
    for (var i = 0; i < GEOM.length; i++) {
      var g = GEOM[i];
      if (typeof layer[g[0]] === 'number' && typeof layer[g[2]] === 'number' &&
          layer[g[2]] > 0) return g;
    }
    return null;
  }

  function board(api) {
    var s = api.spec || {};
    var d = api.doc || {};
    var w = s.widthIn || d.widthIn || d.w;
    var h = s.heightIn || d.heightIn || d.h;
    return (w > 0 && h > 0) ? { w: w, h: h } : null;
  }

  function isImage(l) {
    if (!l) return false;
    var t = String(l.type || l.t || '').toLowerCase();
    if (t) return t === 'image' || t === 'img';
    return !!(l.src || l.url || l.image);
  }

  function pass() {
    var api = window.__dcApi;
    if (!api || !api.doc || !Array.isArray(api.doc.layers)) return;
    var layers = api.doc.layers;
    if (layers.length !== 1) return;

    var l = layers[0];
    if (!isImage(l)) return;

    var id = l.id || l.name || 'only';
    if (done[id]) return;

    var g = geomKeys(l);
    var b = board(api);
    last = { hasGeom: !!g, hasBoard: !!b, layer: l, keys: g };
    if (!g || !b) return;

    var x = l[g[0]], y = l[g[1]], w = l[g[2]], h = l[g[3]];
    var k = Math.min(b.w / w, b.h / h);          // factor for a 100% contain fit
    last.factor = k;
    if (!(k > 1 / HI && k < 1 / LO)) return;     // not the builder's 96% fit

    var offX = Math.abs((x + w / 2) - b.w / 2) / b.w;
    var offY = Math.abs((y + h / 2) - b.h / 2) / b.h;
    last.offX = offX;
    last.offY = offY;
    if (offX > CENTRE_TOL || offY > CENTRE_TOL) return;   // customer moved it

    var nw = w * k, nh = h * k;
    var next = {};
    for (var key in l) next[key] = l[key];
    next[g[0]] = (b.w - nw) / 2;
    next[g[1]] = (b.h - nh) / 2;
    next[g[2]] = nw;
    next[g[3]] = nh;

    done[id] = true;
    try {
      // false = no undo step; the customer did not make this change
      api.setDoc({ layers: [next] }, false);
    } catch (e) {}
  }

  var timer = setInterval(function () { try { pass(); } catch (e) {} }, 500);
  window.addEventListener('pagehide', function () { clearInterval(timer); });

  window.__dcTplFitDebug = function () { return last; };
})();
